var React = require('react');

function Icon(props) {
  return React.cloneElement(
    React.createElement(
      'svg',
      { height: '24', width: '24', viewBox: '0 0 24 24' },
      React.createElement('path', {
        d:
          'M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11.4308 15.626C12.3766 15.626 12.8576 16.0536 12.8576 16.8204C12.8576 17.5723 12.3928 18 11.4308 18C10.4688 18 10.004 17.6166 10.004 16.8204C10.004 16.0536 10.4688 15.626 11.4308 15.626ZM12.1844 7C14.1402 7 16 7.7667 16 10.1555C16 12.0133 14.7654 13.1193 12.6654 13.5764V14.9182H10.2604V12.2198C11.8156 12.1019 13.4508 11.7038 13.4508 10.126C13.4508 9.19707 12.8738 8.84314 12.056 8.84314C11.062 8.84314 10.5491 9.31495 10.3567 10.3767L8 10.0376C8.25644 8.1649 9.69941 7 12.1844 7Z'
      })
    ),
    props
  );
}

module.exports = Icon;
